export const tutorials = {
    LoopCAD: [{
        section: 'Basics',
        title: 'Introduction to LoopCAD',
        duration: '7:15',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/LoopCADIntroduction/LoopCADIntroduction.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 1,
    },
    {
        section: 'Basics',
        title: 'Creating a New Project',
        duration: '9:22',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/CreateNewProject/NewProject.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 2,
    },
    {
        section: 'Basics',
        title: 'Drawing a Floorplan',
        duration: '12:56',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/Floorplans/Floorplan.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 3,
    },
    {
        section: 'Basics',
        title: 'Quick Design Mode',
        duration: '4:37',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/QuickDesign/QuickDesignUP.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 4,
    },
    {
        section: 'Basics',
        title: 'Manifolds and Auto-Circuits',
        duration: '9:52',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ManifoldsCircuits/ManifoldsCircuits.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 5,
    },
    {
        section: 'Basics',
        title: 'Counterflow Circuits',
        duration: '5:13',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/Counterflow/Counterflow.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 6,
    },
    {
        section: 'Basics',
        title: 'Freehand Circuits',
        duration: '6:38',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/FHCircuits/FHCircuits.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 7,
    },
    {
        section: 'Basics',
        title: 'Joist Floors',
        duration: '8:49',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/Joists/Joists.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 8,
    },
    {
        section: 'Basics',
        title: 'Custom Circuit Areas',
        duration: '7:02',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/CircuitAreas/CircuitAreas.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 9,
    },
    {
        section: 'Basics',
        title: 'Review and Analysis Tools',
        duration: '8:50',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/Analysis/Analysis.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 10,
    },
    {
        section: 'Basics',
        title: 'Printing and Exporting',
        duration: '9:00',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/PrintingAndExporting/PrintingExporting.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 11,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Importing an AutoCAD Drawing',
        duration: '4:55',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ImportingACAD/ImportACAD.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 12,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Importing PDF and Scanned Drawings',
        duration: '5:03',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ImportingPDF/ImportPDF.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 13,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Drawing on an Imported Drawing',
        duration: '7:40',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/DrawingOnImportedDrawing/DrawOnImport.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 14,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Exporting to an AutoCAD File',
        duration: '3:48',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ExportingACAD/ExportACAD.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 15,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Heating Load Calculations',
        duration: '22:29',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/HeatLoadCalculations/HeatingLoads.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 16,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Cooling Load Calculations',
        duration: '14:14',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/CoolingLoadCalculations/CoolingLoads.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 17,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Infiltration & Ventilation Loads',
        duration: '6:12',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/InfiltrationAndVentilationLoads/InfiltrationVentilation.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 18,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Entering Heat Loads Manually',
        duration: '4:39',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ManualHeatLoads/ManualHeatLoads.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 19,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Cold/Warm Partitions',
        duration: '3:27',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ColdWarmPartitions/PartitionWalls.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 20,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Walkout Basements',
        duration: '4:37',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/WalkoutBasement/Walkout.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 21,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Vaulted or Cathedral Ceilings',
        duration: '3:00',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/VaultedCathedral/VaultedCeilings.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 22,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Supply/Return Distribution Piping',
        duration: '4:35',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/SupplyReturnDistributionPiping/SRPiping.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 23,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Baseboard Heating',
        duration: '4:06',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/BaseboardHeating/Baseboard.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 24,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Wall and Ceiling Heat',
        duration: '3:22',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/CeilingWall/WallCeiling.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 25,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Adding a Water Supply Temperature',
        duration: '1:24',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/SupplyTemperature/SupplyTemperature.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 26,
    },
    {
        section: 'Snow Melt Systems',
        title: 'Creating a New Snow Melt Project',
        duration: '2:45',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/CreatingSnowMelt/CreateSnowmelt.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 27,
    },
    {
        section: 'Snow Melt Systems',
        title: 'Snow Melt System Design',
        duration: '3:53',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/SnowMeltDesign/Snowmelt.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 28,
    },
    {
        section: 'OEM Editions',
        title: 'Materials Lists & OEM Editions',
        duration: '6:15',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/Materials/Materials.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 29,
    },
    {
        section: 'OEM Editions',
        title: 'Coil Schedule',
        duration: '3:11',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/CoilSchedule/CoilSchedule.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 30,
    },
    {
        section: 'OEM Editions',
        title: 'Spreadsheet Design Mode - Basics',
        duration: '5:39',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/SpreadsheetDesignMode/SSMode.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 31,
    },
    {
        section: 'OEM Editions',
        title: 'Spreadsheet Design Mode - Advanced',
        duration: '10:04',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/SSModeAdvanced/SSModeAdvanced.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 32,
    },
    {
        section: 'OEM Editions',
        title: 'Manual Quotation',
        duration: '4:35',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ManualQuotations/ManualQuote.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 33,
    },
    {
        section: 'Additional Topics',
        title: 'Custom Editing of Circuits',
        duration: '7:41',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/EditingCircuit/EditCircuits.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 34,
    },
    {
        section: 'Additional Topics',
        title: 'Curved Walls and Bump Outs',
        duration: '2:50',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/WallEditing/WallEditing.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 35,
    },
    {
        section: 'Additional Topics',
        title: 'Custom Tables',
        duration: '4:10',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/CustomTables/CustomTables.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 36,
    },
    {
        section: 'Additional Topics',
        title: 'Dimensions and Text',
        duration: '4:54',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/DimensionsText/DimText.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 37,
    },
    {
        section: 'Additional Topics',
        title: 'Relative Coordinates',
        duration: '1:38',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/RelativeCoordinates/RelativeCoord.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 38,
    },
    {
        section: 'Additional Topics',
        title: 'Multi-Floor Manifolds',
        duration: '4:22',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/MultiFloorManifolds/MultiFloorManifolds.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 39,
    },
    {
        section: 'Additional Topics',
        title: 'Inserting Images',
        duration: '1:55',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/InsertImages/InsertImages.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 40,
        isNew: true,
    },
    {
        section: 'Additional Topics',
        title: 'Clerestory Walls and Windows',
        duration: '2:37',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ClerestoryWalls/Clerestory.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 41,
        isNew: true,
    },
    {
        section: 'Additional Topics',
        title: 'Rotating Drawings',
        duration: '2:23',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/RotatingDrawings/RotateDrawing.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 42,
        isNew: true,
    },
    {
        section: 'Additional Topics',
        title: 'Merging Rooms',
        duration: '1:42',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/MergeRooms/MergeRooms.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 43,
        isNew: true,
    }],
    HeatCAD: [{
        section: 'Basics',
        title: 'Introduction to HeatCAD',
        duration: '7:14',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/HeatCADIntroduction/HeatCADIntroduction.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 1,
    },
    {
        section: 'Basics',
        title: 'Drawing a Floorplan',
        duration: '12:56',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/Floorplans/Floorplan.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 2,
    },
    {
        section: 'Basics',
        title: 'Printing and Exporting',
        duration: '9:00',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/PrintingAndExporting/PrintingExporting.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 3,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Importing an AutoCAD Drawing',
        duration: '4:55',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ImportingACAD/ImportACAD.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 4,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Importing PDF and Scanned Drawings',
        duration: '5:03',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ImportingPDF/ImportPDF.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 5,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Drawing on an Imported Drawing',
        duration: '7:40',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/DrawingOnImportedDrawing/DrawOnImport.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 6,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Exporting to an AutoCAD File',
        duration: '3:48',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ExportingACAD/ExportACAD.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 7,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Heating Load Calculations',
        duration: '22:29',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/HeatLoadCalculations/HeatingLoads.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 8,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Cooling Load Calculations',
        duration: '14:14',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/CoolingLoadCalculations/CoolingLoads.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 9,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Infiltration & Ventilation Loads',
        duration: '6:12',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/InfiltrationAndVentilationLoads/InfiltrationVentilation.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 10,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Entering Heat Loads Manually',
        duration: '4:39',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ManualHeatLoads/ManualHeatLoads.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 11,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Cold/Warm Partitions',
        duration: '3:27',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ColdWarmPartitions/PartitionWalls.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 12,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Walkout Basements',
        duration: '4:37',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/WalkoutBasement/Walkout.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 13,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Vaulted or Cathedral Ceilings',
        duration: '3:00',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/VaultedCathedral/VaultedCeilings.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 14,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Baseboard Heating',
        duration: '4:06',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/BaseboardHeating/Baseboard.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 15,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Wall and Ceiling Heat',
        duration: '3:22',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/CeilingWall/WallCeiling.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 16,
    },
    {
        section: 'Additional Topics',
        title: 'Curved Walls and Bump Outs',
        duration: '2:50',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/WallEditing/WallEditing.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 17,
    },
    {
        section: 'Additional Topics',
        title: 'Custom Tables',
        duration: '4:10',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/CustomTables/CustomTables.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 18,
    },
    {
        section: 'Additional Topics',
        title: 'Dimensions and Text',
        duration: '4:54',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/DimensionsText/DimText.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 19,
    },
    {
        section: 'Additional Topics',
        title: 'Relative Coordinates',
        duration: '1:38',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/RelativeCoordinates/RelativeCoord.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 20,
    },
    {
        section: 'Additional Topics',
        title: 'Inserting Images',
        duration: '1:55',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/InsertImages/InsertImages.mp4',
        firstFrame: 'FirstFrame.png',
        isNew: true,
        sortOrder: 21,
    },
    {
        section: 'Additional Topics',
        title: 'Clerestory Walls and Windows',
        duration: '2:37',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/ClerestoryWalls/Clerestory.mp4',
        firstFrame: 'FirstFrame.png',
        isNew: true,
        sortOrder: 22,
    },
    {
        section: 'Additional Topics',
        title: 'Rotating Drawings',
        duration: '2:23',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/RotatingDrawings/RotateDrawing.mp4',
        firstFrame: 'FirstFrame.png',
        isNew: true,
        sortOrder: 23,
    },
    {
        section: 'Additional Topics',
        title: 'Merging Rooms',
        duration: '1:42',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/MergeRooms/MergeRooms.mp4',
        firstFrame: 'FirstFrame.png',
        isNew: true,
        sortOrder: 24,
    }],
    PlumbingCAD: [{
        section: 'Basics',
        title: 'Introduction to PlumbingCAD',
        duration: '8:20',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/PlumbingCADIntroduction/PlumbingCADIntroduction.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 1,
    },
    {
        section: 'Basics',
        title: 'Importing a PDF Drawing',
        duration: '4:34',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/PlumbingCADImportingPDF/PCADImportingPDF.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 2,
    },
    {
        section: 'Basics',
        title: 'Importing an AutoCAD Drawing',
        duration: '4:25',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/PlumbingCADImportingDWG/PCADImportingDWG.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 3,
    },
    {
        section: 'Basics',
        title: 'Defining the Plumbing System',
        duration: '12:30',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/PlumbingCADDefiningPlumbing/PCADDefiningPlumbing.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 4,
    },
    {
        section: 'Basics',
        title: 'Materials Lists and Quotations',
        duration: '5:50',
        path: 'https://www.avenir-online.com/AvenirWeb/Tutorials/PlumbingCADMatListsAndQuotations/PCADMaterialsLists.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 5,
    }]
}

